import { ROUTER_PATH } from "@/src/config/router";

function portfolioLocalePathPrefix(locale: string): string {
  return locale === "en" ? "" : `/${locale}`;
}

export type PortfolioRouteNamespace = "copilot" | "invest";

const INVEST_PORTFOLIO_PREFIX = `${ROUTER_PATH.INVEST}/portfolio`;

export function resolvePortfolioNamespace(
  pathname: string,
): PortfolioRouteNamespace {
  const p = pathname || "";
  if (p.includes("/invest/portfolio")) {
    return "invest";
  }
  return "copilot";
}

function portfolioRootForNamespace(namespace: PortfolioRouteNamespace): string {
  return namespace === "invest"
    ? INVEST_PORTFOLIO_PREFIX
    : ROUTER_PATH.CO_PILOT_PORTFOLIO;
}

/** @param localePrefix 浏览器路径 locale 前缀（英文为 `""`，见 `investLocalePathPrefix`） */
export function portfolioImportPath(
  namespace: PortfolioRouteNamespace,
  localePrefix = "",
): string {
  const prefix = (localePrefix ?? "").replace(/\/+$/, "");
  const base =
    namespace === "invest"
      ? `${INVEST_PORTFOLIO_PREFIX}/import`
      : ROUTER_PATH.CO_PILOT_PORTFOLIO_IMPORT;
  return prefix ? `${prefix}${base}` : base;
}

export function portfolioImportPathForLocale(
  locale: string,
  namespace: PortfolioRouteNamespace,
): string {
  return portfolioImportPath(namespace, portfolioLocalePathPrefix(locale));
}

export function portfolioHoldingsPath(
  namespace: PortfolioRouteNamespace,
  portfolioId: string,
  localePrefix = "",
): string {
  const prefix = (localePrefix ?? "").replace(/\/+$/, "");
  const encodedId = encodeURIComponent(portfolioId);
  const base = `${portfolioRootForNamespace(namespace)}/${encodedId}`;
  return prefix ? `${prefix}${base}` : base;
}

export function portfolioHoldingsPathForLocale(
  locale: string,
  namespace: PortfolioRouteNamespace,
  portfolioId: string,
): string {
  return portfolioHoldingsPath(
    namespace,
    portfolioId,
    portfolioLocalePathPrefix(locale),
  );
}

export function portfolioRootPath(
  namespace: PortfolioRouteNamespace,
  localePrefix = "",
): string {
  const prefix = (localePrefix ?? "").replace(/\/+$/, "");
  const base = portfolioRootForNamespace(namespace);
  return prefix ? `${prefix}${base}` : base;
}

export function isPortfolioImportPath(pathname: string): boolean {
  const p = pathname || "";
  return (
    p === ROUTER_PATH.CO_PILOT_PORTFOLIO_IMPORT ||
    p === `${INVEST_PORTFOLIO_PREFIX}/import` ||
    p.endsWith("/invest/portfolio/import")
  );
}

export function isInvestPortfolioHomePath(pathname: string): boolean {
  const p = pathname || "";
  if (p === INVEST_PORTFOLIO_PREFIX) {
    return true;
  }
  if (!p.startsWith(`${INVEST_PORTFOLIO_PREFIX}/`)) {
    return false;
  }
  return true;
}
